import { PlatformEnum } from '@/settings/enum';
import styles from '@/settings/styles/settings/menu_header_render.less';
import { classes_module } from '@/utils/class-module';
import { useModel } from '@@/exports';
import { MoneyCollectFilled } from '@ant-design/icons';
import { Space, Typography } from 'antd';
import { Suspense, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { ProjectListDrawer } from './component';

/**
 * 菜单顶部dom样式
 * 渲染 logo 和 title, 优先级比 headerTitleRender 更高
 * ReactNode | (logo,title)=>ReactNode
 */
export default () => {
  const [collapsed, setCollapsed] = useState(false);
  const [isCompany, setIsCompany] = useState(true);
  const { initialState } = useModel('@@initialState');
  const platform = useSelector((state: any) => state.platform);

  const [value, setValue] = useState('进入项目');

  useEffect(() => {
    setCollapsed(!!initialState?.collapsed);
  }, [initialState]);

  useEffect(() => {
    const type = platform[PlatformEnum.TYPE];
    setIsCompany(type > 1);
    if (type === 3) {
      const project = platform[PlatformEnum.PROJECT];
      setValue(project.project_name);
    }
  }, [platform]);
  return (
    isCompany && (
      <Suspense fallback={'2'}>
        <ProjectListDrawer>
          <div className={classes_module(styles, 'menuHeaderRender-container')}>
            <Typography.Paragraph
              style={{
                width: '100%',
                marginBottom: '0',
              }}
              ellipsis={{
                rows: 2,
                tooltip: value,
              }}
            >
              <Space size={4}>
                <MoneyCollectFilled className={classes_module(styles, 'menuHeaderRender-content-icon')} />
                {!collapsed && (
                  <Typography.Text
                    copyable={{
                      text: value,
                      tooltips: ['复制项目名称', '复制成功！'],
                    }}
                    className={classes_module(styles, 'menuHeaderRender-content-title')}
                  >
                    {value}
                  </Typography.Text>
                )}
              </Space>
            </Typography.Paragraph>
          </div>
        </ProjectListDrawer>
      </Suspense>
    )
  );
};
